import moment from "moment"
import AppConfig from './AppConfig.json'

export function getCardNo(profile) {
    return profile.cards[0].cardNo
}
export function isT1X(profile) {
    let isT1X = false

    try {
        if (profile.segments) {
            for (let s in profile.segments) {
                if (profile.segments[s].segmentLevel === "T1X") {

                    if (profile.segments[s].endDate) {
                        let isExpire = moment(profile.segments[s].endDate, 'DDMMYYYY').isBefore(moment())
                        console.log(moment(profile.segments[s].endDate, 'DDMMYYYY').format(), moment(profile.segments[s].endDate, 'DDMMYYYY').isAfter(moment()))
                        isT1X = !isExpire
                    }
                    break
                }
            }
        }
    }
    catch (e) {
        console.error(e)
    }

    return isT1X
}



export function isMissionStickerCampaign() {
    let startDate = moment('2022-07-12 09:00:00+7:00', "YYYY-MM-DD HH:mm:ssz")
    let endDate = moment('2022-10-9 22:00:00+7:00', "YYYY-MM-DD HH:mm:ssz")
    let isInPeriod = (moment().isAfter(startDate) && moment().isBefore(endDate))
    // console.log(AppConfig.env)
    // console.log(startDate)
    // console.log(endDate)
    // console.log(isInPeriod)
    return AppConfig.env === 'prod' && isInPeriod
}
